import { ConvertedFarm } from "./helpers";
import { Farm } from "protos/farm/farm";
import { Feature } from "geojson";
import { FeatureCollectionWithFilename } from "shpjs";
import React from "react";

export enum ShapefileLoadingState {
  NotStarted = "not-started",
  Loading = "loading",
  Ok = "ok",
  Error = "error",
}

export interface ShapefileBundleWizardProps {
  customerId: number | undefined;
  setCustomerId: (customerId: number | undefined) => void;
  shapefileLoadingState: ShapefileLoadingState;
  shapefile: FeatureCollectionWithFilename[];
  resetShapefile: () => void;
  inputFeatures: Feature[];
  propertyExamples: Map<string, Set<string>>;
  farmNameTemplate: string[];
  setFarmNameTemplate: (template: string[]) => void;
  fieldNameTemplate: string[];
  setFieldNameTemplate: (template: string[]) => void;
  convertedFarms: ConvertedFarm[];
  busyConverting: boolean;
  nImportableFields: number;
  displaySelectedGeoIds: string[];
  toggleSelection: (geoId: string) => void;
  resetSelection: () => void;
  focusGeoId: (geoId: string) => void;
  farmsForImport: Farm[];
}

export interface WizardStep<TProps> {
  stepNameI18NKey: string;
  Render: React.FC<TProps>;
  mapSelectionEnabled: boolean;
  canAdvancePastStep: (context: TProps) => boolean;
}
